<template>
  <TrainerLayout>
    <div class="pb-4">
      <div class="flex flex-col md:flex-row justify-between items-center mb-6">
        <h6
          class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
        >
          My {{
                $route.params.id == "all"
                  ? ""
                  : $route.params.id == 1
                  ? "Class"
                  : "Class Pack"
              }} Templates
        </h6>
        <div class="space-x-4">
          <div class="relative inline-block text-left">
            <button
              type="button"
              class="h-10 px-4 text-sm text-gray-700 transition-colors duration-150 bg-gray-lightest rounded-md focus:outline-none hover:bg-gray-lightest flex items-center hover:shadow-xl"
              @click="isShowAllOpen = !isShowAllOpen"
            >
              Show:
              {{
                $route.params.id == "all"
                  ? "All"
                  : $route.params.id == 1
                  ? "Classes"
                  : "Class Packs"
              }}
              <ChevronDown />
            </button>

            <div
              class="origin-top-right absolute md:right-0 mt-2 md:w-56 w-40 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 z-10"
              v-if="isShowAllOpen"
            >
              <div
                class="py-0"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <router-link
                  :to="{ name: 'sessions', params: { id: 'all' } }"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                  exact-active-class="text-green-light"
                  >All</router-link
                >
                <router-link
                  :to="{ name: 'sessions', params: { id: 1 } }"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                  exact-active-class="text-green-light"
                  >Classes</router-link
                >
                <router-link
                  :to="{ name: 'sessions', params: { id: 2 } }"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                  exact-active-class="text-green-light"
                  >Class Packs</router-link
                >
              </div>
            </div>
          </div>
          <div class="relative inline-block text-left">
            <div>
              <button
                type="button"
                class="h-10 px-4 text-sm text-white transition-colors duration-150 ring-1 ring-green-light bg-green-light rounded-full focus:outline-none flex items-center hover:text-green-light hover:bg-white"
                id="options-menu"
                aria-haspopup="true"
                aria-expanded="true"
                @click="isAddNewOpen = !isAddNewOpen"
              >
                Add New <Plus />
              </button>
            </div>
            <div
              class="origin-top-right absolute md:right-0 mt-2 md:w-56 w-40 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 z-10"
              v-if="isAddNewOpen"
            >
              <div
                class="py-0"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <router-link
                  :to="{ name: 'createSession' }"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                >
                  Class
                </router-link>
                <router-link
                  :to="{ name: 'createCourse' }"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                >
                  Class Pack
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="clear-both">
        <div
          class="grid lg:grid-cols-3 xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 xl:gap-6"
          v-if="trainerSessionListData && trainerSessionListData.length"
        >
          <div v-for="(d, i) in trainerSessionListData" :key="i">
            <router-link
              :to="{ name: 'course', params: { id: d.id } }"
              v-if="d.entity_type == 2"
            >
              <!-- <CourseSessionListingCard :d="d" :isTrainerName="false" /> -->
              <Card :data="d" :isTrainerName="false" :isFavourite="true" :isLanguage="false" :isRating="false"/>
            </router-link>
            <router-link :to="{ name: 'session', params: { id: d.id } }" v-else>
              <!-- <CourseSessionListingCard :d="d" :isTrainerName="false" /> -->
              <Card :data="d" :isTrainerName="false" :isFavourite="true" :isLanguage="false" :isRating="false"/>
            </router-link>
          </div>
        </div>
        <div v-if="loadingStatus">
          <ContentLoader :size="4" :type="'session'"></ContentLoader>
        </div>
        <!-- v-if="trainerSessionList && trainerSessionList.statusCode == 404" -->
        <div
          class="flex flex-col justify-center items-center text-xl text-gray-700 text-center"
          v-else-if="!(trainerSessionListData && trainerSessionListData.length) && !loadingStatus"
        >
          <img
            :src="require(`@/assets/img/my_sessions_no_data.svg`)"
            alt="..."
            class="w-72 h-72"
          />
          <div class="flex flex-col justify-center items-center">
            <span> Looks like there is nothing here yet.</span>
            <span>Create a new Class by clicking on add new +</span>
          </div>
        </div>

        <Pagination
          v-if="totalPages"
          :currentPage="currentPage"
          :handlePageChange="handlePageChange"
          :totalPages="totalPages"
        />
      </section>
    </div>
  </TrainerLayout>
</template>

<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import TrainerLayout from "@/components/layouts/TrainerLayout";
//import CourseSessionListingCard from "@/components/CourseSessionListingCard.vue";
import { Pagination } from "@/components/t-components";
import { ChevronDown, Plus } from "@/components/icons";
import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters } from "vuex";
import Card from "@/components/card/Card.vue";

export default {
  name: "Sessions",
  components: {
    TrainerLayout,
    //CourseSessionListingCard,
    Pagination,
    ChevronDown,
    Plus,
    ContentLoader,
    Card,
  },
  data() {
    return {
      isAddNewOpen: false,
      isShowAllOpen: false,
      trainerSessionListData: [],
      currentPage: 1,
      totalPages: "",
    };
  },
  computed: {
    ...mapGetters(["trainerSessionList"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  watch: {
    $route() {
      const query = {
        page: this.currentPage,
      };
      this.getTrainerSessionList({ id: this.$route.params.id, query });
    },
  },
  methods: {
    ...mapActions(["getTrainerSessionList"]),

    hideIsAddNewOpen() {
      this.isAddNewOpen = false;
    },

    hideIsShowAllOpen() {
      this.isShowAllOpen = false;
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      this.trainerSessionListData = [];
      await this.getTrainerSessionList({ id: this.$route.params.id, query });
      this.trainerSessionListData =
        (this.trainerSessionList &&
          this.trainerSessionList.data &&
          this.trainerSessionList.data.data) ||
        [];
    },
  },
  async created() {
    const query = {
      page: this.currentPage,
    };
    await this.getTrainerSessionList({ id: this.$route.params.id, query });
    this.trainerSessionListData =
      (this.trainerSessionList &&
        this.trainerSessionList.data &&
        this.trainerSessionList.data.data) ||
      [];
    this.totalPages =
      this.trainerSessionList &&
      this.trainerSessionList.data &&
      this.trainerSessionList.data.last_page;
  },
  directives: {
    ClickOutside,
  },
};
</script>